<!--
 * @创建文件时间: 2020-04-14 20:17:36
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-23 14:24:17
 * @联系Qq:1360484677
 * @文件介绍: 
 -->
<template>
<el-form-item :label="form.name" :prop="form.model"
               :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
                >
  <el-cascader
    ref="pers"
    v-model="value[form.model]"
    :options="optionData"
    :disabled="inputDisable"
    filterable
    :clearable="true"
    
    style="width:226px"
    :placeholder="form.options.placeholder"
    :show-all-levels="false"
    :props="{ label:'name',value:'guid',children:form.options.props.children,checkStrictly: true,emitPath:false }"
    @change="onInput"></el-cascader>
</el-form-item>
</template>

<script>
export default {
  name: 'persCascader',
  // components: {},
  data () {
    return {
      loading: false,
      key: '',
      mainValue: [],
      formData: { value: '' },
      optionData:[],
      remoteSearchFunc: () => {
      }
    }
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            defaultValue: [],
            width: "",
            placeholder: "",
            disabled: false,
            clearable: false,
            remote: true,
            remoteOptions: [],
            props: {
              value: "id",
              label: "name",
              children: "children"
            },
            customClass: "1",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,//管养（true）//养护(false)
            showLast:false,
            remoteFunc: () => {
            },
            remoteSearch: false,
            remoteSearchFunc: () => {
            }
          },
          key: '',
          model: 'value',
          modelLabel:'value1',
          department:false,
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.mainValue = val
      }
    },
    "form.options.remoteOptions":function(newVal,oldVal){
      this.optionData = newVal
    }
  },
  methods: {
    onInput (val) {
      let that = this
      let nodes=this.$refs.pers.getCheckedNodes();
      if(nodes.length>0){
        let label = nodes[0].label
         this.value[this.form.modelLabel] = label
      }else{
        this.value[this.form.modelLabel] = ""
      }
      val==null&&(this.value[this.form.model]="0");
      this.$emit('input', that.form.model, that.mainValue)
      if (typeof that.form.options.changeFunc === 'function') {
         that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
      // this.getPers();
    },
    //获取组织机构
    getPers(){
      let layers=this.form.options.customClass
       this.$http.postX(this.$url.authority.getpermissionnewtree, {isPublic:layers}).then(res => {
         this.optionData = res.data;
      });
    }
  },
  created () {
     //在初次加载的时候，将是否开启部门搜索设置为false
     if(this.form.department===undefined){
       this.form.department = false
     }
     this.getPers()
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
    	//点击文本就让它自动点击前面的input就可以触发选择。但是因组件阻止了冒泡，暂时想不到好方法来触发。
	//这种比较耗性能，暂时想不到其他的，能实现效果了。
    setInterval(function() {
      document.querySelectorAll(".el-cascader-node__label").forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click();
        };
      });
    }, 1000);
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/PersCascader.vue"
}
</vue-filename-injector>
